import { render, staticRenderFns } from "./holidayActMaleMain.vue?vue&type=template&id=6b5893f8&scoped=true"
import script from "./holidayActMaleMain.vue?vue&type=script&lang=js"
export * from "./holidayActMaleMain.vue?vue&type=script&lang=js"
import style0 from "./holidayActMaleMain.vue?vue&type=style&index=0&id=6b5893f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5893f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5893f8')) {
      api.createRecord('6b5893f8', component.options)
    } else {
      api.reload('6b5893f8', component.options)
    }
    module.hot.accept("./holidayActMaleMain.vue?vue&type=template&id=6b5893f8&scoped=true", function () {
      api.rerender('6b5893f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/NewYearsDay/holidayActMaleMain.vue"
export default component.exports